export const en = {
  //   header
  home: "Home",
  Gifts: "Gifts",
  Courses: "Courses",
  About: "About",
  Settings: "Settings",
  Profile: "Profile",
  SignOut: "Sign Out",
  learning: "Education & Training",
  Lecturers: "Lecturers",
  JobOpportunities: "Job opportunities",
  JobSeeker: "Job seeker",
  next: "Next",
  prev: "Previous",
  send: "Send",

  // home
  CelebritiesTitle: "Celebrities in sports",
  REMOVE: "REMOVE",
  FOLOW: "FOLOW",
  cvSectoinTitle: "Employment",
  SeeMore: "See More",
  NoCvs: "No Cvs Founded!",
  freeCourses: "Training programs",
  voteTitle: "Our agents",
  playIn: "agent ",
  Vote: "Vote",
  alreadyotVed: "You have already voted.",
  VotedSuccessfully: "Voted Successfully",
  loginToVote: "Please log in to vote.",
  uploadeCVtitle: "Upload your CV Now",
  uploadeCVdesc:
    "Your CV has been uploaded successfully, we will review and publish it.",
  uploadCV: "Upload CV",
  cvLoadedSuccessfly: "Your CV has been uploaded successfully",
  ok: "I=Ok",
  whatsapp: "whatsapp",
  canTravel: "Available for travel",

  //   courses
  allCourses: "All Courses",
  courseBannerTitle: "Subscribe to the special packages",
  courseBannerDesc:
    "To get the highest return when inviting your friends, what are you waiting for? Hurry up and register.",
  learnMore: "learn More",
  enrollNow: "enroll Now",
  enrollNowFree: "enroll Now",
  shareCourse: "Share",
  share: "Share",
  enrollWithOffer: (num) => {
    if (num === 0) {
      return `Enroll Now`;
    }
    return `Enroll With ${num}% offer`;
  },
  popupMessage:
    "Please note that you only have 2 free training programs per month. To book any other programs during the same month, you will be at a 90% discount on the total price of the training program for a period of three months only. Free registration for training programs starts from the 1st to the 10th of each month. To learn about the price list and discounts, contact ",
  pcustomerService: "customer service.",
  welcome: "Welcome",
  close: "Close",
  courseMessage:
    "You will be transferred to customer service to learn about the discount list for training programs and the set prices.",
  successfullyRegisteredCourse:
    "You have successfully registered for the course.",
  registrationNote:
    "Please note that this information will be printed on the certificate you will receive after completing the course. Please write all information in English.",

  // footer
  Links: "Links",
  customerService: "For complaints and customer service",
  coursesRules: "Rules for obtaining training programs",
  certificatesRules: "Rules for obtaining certificates",
  verifyCertificates: "Verify certificates",
  Partners: "Partners",
  workWithUs: "Work with us",
  advertiseWithUs: " advertise",
  aboutSportsIn: "About sports in",
  goals: "We aim to serve Arab youth by helping in:",
  goal1:
    "Publishing and promoting sports recruitment ads with our partners in Saudi Arabia and the UAE.",
  goal2:
    "Get free training programs in the sports field, with accreditations from international companies, as the Sports in website plays the role of mediation as a company that manages websites and electronic applications within the sports field in providing the best free experiences for its users, as well as free training programs with accreditations from our partners and advertisers.",
  goal3: "Join the list of celebrities in Sports in",
  goal4:
    "Making profit for users through paid service packages, which are included in gifts.",
  rights: "All rights reserved to sports in and partners",
  cooperation: "In cooperation with",
  privacy: "privacy policy",

  // profile
  myCourses: "My courses",
  shareProfile: "share Profile",
  editProfile: "Edit Profile",
  userDesc: "No descriptoin",
  inviteLink: "Copy invitation link",
  getReward: "Invite your friends to get rewards",
  noJob: "No Job",
  userLocation: "No Location",
  complete: "Complete",
  CompleteInformation: "Complete your information",
  addCv: "Add CV",
  save: "Save",
  ProfileUpdatedSuccessfully: "Profile updated successfully",
  applyNow: "Apply now",
  Paid: "Paid",
  free: "Free",
  searchForJob: "Find suitable job opportunities",

  // validation
  required: "This field is required",
  error: "Error",

  // auth
  login: "Login",
  register: "Register",
  forgotPassword: "Forgot Password",
  resetPassword: "Reset Password",
  country: "Country",
  years: "Years",

  // trainers
  trainersTitle: "Trainees",
  name: "Name",
  email: "Email",
  Nationality: "Nationality",
  program: "Programs",
  code: "Code",
  trainers: "Trainers",
  trainerFormMessage:
    "Registration Successful! Thank you for registering as a certified trainer.Your information will be reviewed, and we will contact you soon to complete the next steps.If you have any questions, feel free to reach out to us.",
  lectureFormMessage:
    "Registration Successful! Thank you for registering as a certified instructor. Your information will be reviewed and we will contact you shortly to complete the next steps. If you have any questions, please feel free to contact us.",
  jobSeekerFormMessage:
    "Registration Successful! Thank you for registering with us. Your information will be reviewed and we will contact you shortly to complete the next steps. If you have any questions, please feel free to contact us.",
  // Institutions
  Institutions: "Institutions",
  Institutions2: "Institutions :",
  allInstitutions: "All Institutions",
  allCountries: "All countries",
  country: "Country :",
  academy: "Academies",
  gym: "Gyms",
  filters: "Filters",
  noInstitutions: "No Institutions founded",
  joinInstitutions:
    "Join us now and showcase your academy to unlock more opportunities for interns with Esporrts.",
  joinTrainers: "Join us now and share your sports experiences with others.",
  joinNow: "Join Now",
  photos: "Photos",
  opiningTimes: "Opining Times :",
  teamwork: "Teamwork",
  leader: "General Manager:",
  leader2: "Manager",
  contactInstitutions: "Contact the institution",
  subscription: "Subscription",
  pound: "L.E",
  subscripe: "subscripe",
  lecturingFildes: "Lecturing Fields:",
  expYears: "Years of experience",
  location: "Location: ",
  personalInfo: "Personal Information",
  services: "Services",
  qualifications: "Qualifications",
  expWork: "Work Experience",
  experience: "Experience",
  workIn: "Works in",
  achievements: "Achievements",
  jobInformations: "Job Informations",
  jobTitle: "Job Title :",
  companyName: "Company Name",
  jobDescription: "Job Description",
  good: "Good",
  verygood: "Very good",
  excellent: "excellent",
  salary: "Salary",
  lastApplayDate: "Last date for application",
  reqQualifications: "Required qualification",
  male: "Male",
  female: "Female",
  type: "Type",
  englishLevel: "English Level",
  responsability: "Responsibility",
  jobOwner: "Job Owner",
  jobOwneDescription:
    "Announcement of the need for employees in the sports field",
  jobType: "Type of work",
  fullTime: "Full time",
  partTime: "Part time",
  freelance: "Freelance",
  jobOpportunityFormMessage:
    "Registration Successful! Thank you for registering with us. If you have any questions, please feel free to contact us.",
  inEnglish: "in English ",
  contactNow: "Contact now",
  cvs: "CVs",
  search: "Search",
  certificates: "Certificate",
  all: "All",
  trainee_courses: "Trainee Courses",
  trainee_certificates: "Trainee Certificates",
  youMustAddPhoneAndEmailBefore: "You must add phone and email first",
};

export const ar = {
  //   header
  home: "الرئيسية",
  Gifts: "الهدايا",
  Courses: "الكورسات",
  About: "من نحن",
  Settings: "الاعدادات",
  Profile: "الملف الشخصي",
  SignOut: "تسجيل الخروج",
  learning: "التعليم والتدريب",
  Lecturers: "المحاضرون",
  JobOpportunities: "فرص العمل",
  JobSeeker: "طالب عمل",
  next: "التالي",
  prev: "السابق",
  send: "إرسال",

  // home
  CelebritiesTitle: "مشاهير في الرياضة",
  REMOVE: "إزاله",
  FOLOW: "متابعة",
  cvSectoinTitle: "التوظيف",
  SeeMore: "المزيد",
  NoCvs: "لا يوجد سيره ذاتيه",
  freeCourses: " البرامج التدريبية ",
  voteTitle: "وكلائنا",
  playIn: " وكيل ",
  Vote: "صوت",
  alreadyotVed: "لقد قمت بالتصويت بالفعل.",
  VotedSuccessfully: "تم التصويت بنجاح",
  loginToVote: "يرجى تسجيل الدخول للتصويت.",
  uploadeCVtitle: "حمل سيراتك الذاتيه الان",
  uploadeCVdesc: "لقد تم تحميل سيرتك الذاتية بنجاح، سنقوم بمراجعتها ونشرها.",
  uploadCV: "اضف السيرة الذاتية مجانا",
  cvLoadedSuccessfly: "لقد تم تحميل سيرتك الذاتية بنجاح",
  ok: "موافق",
  whatsapp: "واتساب",
  canTravel: "متاح للسفر",

  //   courses
  allCourses: "جميع الكورسات",
  courseBannerTitle: "اشترك في العروض الخاصة",
  courseBannerDesc:
    "للحصول على أعلى عائد عند دعوة أصدقائك، ما الذي تنتظره؟ سارع بالتسجيل.",
  learnMore: "اعرف المزيد",
  enrollNow: "سجل الان",
  enrollNowFree: "سجل الان ",
  shareCourse: "مشاركه الكورس",
  share: "مشاركه ",
  enrollWithOffer: (num) => {
    if (num === 0) {
      return "سجل الان";
    }
    return `سجل مع خصم ${num}%`;
  },
  popupMessage:
    "يرجي العلم أنه لديك عدد 2 برنامج تدريبي فقط بشكل مجاني خلال الشهر الواحد، لحجز أي برامج أخري خلال نفس الشهر سوف تكون بخصم 90% من إجمالي سعر البرنامج التدريبي وذلك فقط لمدة ثلاثة أشهر، كما يبدأ التسجيل المجاني للبرامج التدريبية من يوم 1 حتي 10 من كل شهر، للتعرف علي لائحة الأسعار والخصومات تواصل مع ",
  pcustomerService: " خدمةالعملاء.",
  welcome: "مرحبا",
  close: "إغلاق",
  courseMessage:
    "سيتم تحويلك الي خدمه العملاء للتعرف علي لائحة الخصم للبرامج التدريبية والاسعار المقرره",
  successfullyRegisteredCourse: "لقد قمت بالتسجيل في الدورة بنجاح.",
  registrationNote:
    "يرجى ملاحظة أن هذه المعلومات سيتم طباعتها على الشهادة التي ستحصل عليها بعد إكمال الدورة. يرجى كتابة جميع المعلومات باللغة الإنجليزية.",

  // footer
  Links: "روابط هامة",
  customerService: "الشكاوي وخدمة العملاء",
  coursesRules: " قواعد الحصول علي البرامج التدريبية",
  certificatesRules: "قواعد الحصول علي الشهادات",
  verifyCertificates: "التحقق من الشهادات",
  Partners: "الشركاء",
  workWithUs: "العمل معنا",
  advertiseWithUs: "للإعلان معنا",
  aboutSportsIn: "نبذة عن sports in",
  goals: "نستهدف خدمة الشباب العربي من خلال المساعدة في:",
  goal1:
    "نشر إعلانات التوظيف بالمجال الرياضي، والترويج لها مع شركاؤنا داخل السعودية والإمارات.",
  goal2:
    "الحصول على برامج تدريبية مجانية في المجال الرياضي، بإعتمادات من شركات دولية، حيث يلعب موقع  Sports in  دور الوساطة كونها شركة لإدارة المواقع والتطبيقات الإلكترونية داخل المجال الرياضي في توفير أفضل التجارب المجانية لمستخدميها، وايضا البرامج التدريبية المجانية باعتمادات الشركاء، والمعلنين لدينا.",
  goal3: " الإنضمام لقائمة المشاهير داخل Sports in",
  goal4:
    "تحقيق الربح لدي المستخدمين من خلال باقات الخدمات المدفوعة، والموجودة داخل الهدايا.",
  rights: "جميع الحقوق محفوظه لدي sports in و شركاه",
  cooperation: "بالتعاون مع",
  privacy: "سياسة الخصوصية",

  // profile
  myCourses: "كورساتي",
  shareProfile: "مشاركه الملف الشخصي",
  editProfile: "تعديل الملف الشخصي",
  userDesc: "لا يوجد وصف",
  inviteLink: "نسخ رابط الدعوة",
  getReward: " قم بدعوة أصدقائك للحصول على المكافآت",
  noJob: "لا يوجد وظيفه",
  userLocation: "لا يوجد عنوان",
  complete: "إكمال",
  CompleteInformation: "أكمل معلوماتك",
  addCv: "اضف سيره ذاتية",
  save: "حفظ",
  ProfileUpdatedSuccessfully: "تم تحديث الملف الشخصي بنجاح",
  applyNow: "اشترك الآن",
  Paid: "مدفوعه",
  free: "مجانيه",
  searchForJob: "ابحث عن فرص العمل المناسبة",

  // validation
  required: "هذا الحقل مطلوب",
  error: "خطا",

  // auth
  login: "تسجيل الدخول",
  register: "تسجيل",
  forgotPassword: "نسيت كلمة المرور",
  resetPassword: "إعادة تعيين كلمة المرور",
  country: "الدوله",
  years: "سنه",

  // trainers
  trainersTitle: "المتدربين",
  name: "الاسم",
  email: "الايميل",
  Nationality: "الجنسيه",
  program: "البرامج",
  code: "الكود",
  trainers: "المدربين",
  trainerFormMessage:
    "تم التسجيل بنجاح! شكراً لتسجيلك كمدرب معتمد.سيتم مراجعة بياناتك والتواصل معك قريباً لاستكمال الخطوات اللازمة.إذا كان لديك أي استفسار، لا تتردد في التواصل معنا.",
  lectureFormMessage:
    "تم التسجيل بنجاح! شكرًا لك على التسجيل كمحاضر معتمد. سيتم مراجعة معلوماتك وسنتواصل معك قريبًا لإكمال الخطوات التالية. إذا كانت لديك أي أسئلة، فلا تتردد في التواصل معنا.",
  jobSeekerFormMessage:
    "تم التسجيل بنجاح! نشكرك على التسجيل معنا. سيتم مراجعة معلوماتك وسنتصل بك قريبًا لاستكمال الخطوات التالية. إذا كانت لديك أي أسئلة، فلا تتردد في الاتصال بنا.",
  // Institutions
  Institutions: "المؤسسات",
  Institutions2: "المؤسسات :",
  allInstitutions: "جميع المؤسسات",
  allCountries: "جميع الدول ",
  country: "الدولة :",
  academy: "الاكاديميات",
  gym: "جيمات",
  filters: "التصنيفات حسب",
  noInstitutions: "لا يوجد اي مؤسسة",
  joinInstitutions:
    "انضم الينا الان واعرض اكاديميتك لفتح لك فرص لمتدربين اكتر مع اسبوررتس ان",
  joinTrainers: "انضم إلينا الآن وشارك تجاربك الرياضية مع الآخرين.",
  joinNow: "انضم الان",
  photos: "الصور",
  opiningTimes: "مواعيد العمل :",
  teamwork: "طاقم العمل",
  leader: "المدير العام :",
  leader2: "المدير",
  contactInstitutions: "تواصل مع المؤسسه",
  subscription: "الاشتراكات",
  pound: "ج.م",
  subscripe: "اشترك",
  lecturingFildes: "مجالات التدريس: ",
  expYears: "سنوات من الخبرة",
  location: "مكان التواجد: ",
  personalInfo: "المعلومات الشخصية",
  services: "الخدمات",
  qualifications: "المؤهلات",
  expWork: "الخبرات العمليه",
  experience: "خبرة",
  workIn: "يعمل في",
  achievements: "الانجازات",
  jobInformations: "معلومات عن الوظيفة",
  jobTitle: "عنوان الوظيفة:",
  companyName: "اسم الجهة",
  jobDescription: "الوصف وظيفي:",
  good: "جيد",
  verygood: "جيد جدا",
  excellent: "ممتاز",
  salary: "الراتب",
  lastApplayDate: "اخر موعد للتقديم",
  reqQualifications: "المؤهل المطلوب",
  male: "ذكر",
  female: "انثي",
  type: "النوع",
  englishLevel: "مستوي الانجليزية",
  responsability: "المهام والمسؤوليات",
  jobOwner: "صاحب عمل",
  jobOwneDescription: "اعلان عن احتياج موظفين في المجال الرياضي",
  jobType: "نوع الدوام",
  fullTime: "دوام كامل",
  partTime: "دوام جزئي",
  freelance: "عمل حر",
  jobOpportunityFormMessage:
    "تم التسجيل بنجاح! نشكرك على التسجيل معنا. إذا كانت لديك أي أسئلة، فلا تتردد في الاتصال بنا.",
  inEnglish: " في الإنجليزية",
  contactNow: "تواصل الان",
  cvs: "السير الذاتية",
  search: "بحث",
  certificates: " كود الشهادات",
  all: "الكل",
  trainee_courses: "كورسات المتدرب",
  trainee_certificates: "شهادات المتدرب",
  youMustAddPhoneAndEmailBefore:
    "يجب عليك اضافة رقم الهاتف والبريد الالكتروني اولا",
};
